import { useStoreValue } from '@core'
import { Store } from '@core/types'
import { getAppContext } from 'src/context/AppContext'
import { LangDict } from 'src/i18n/lib/texts/types'
import { Language } from 'src/api/defs/enums.type'

export const useLangSource = <T>(src: LangDict<T>, store?: Store<Language>) => {
    const lang = useStoreValue(store ?? getAppContext().i18n.language)

    return src[lang]
}
